export const notificationsConfig = (intl, history) => notification => {
  const opts = {
    'processing-group-creation': {
      snackbarMessage: intl.formatMessage({
        id: 'NOTIFICATIONS.GROUP_CREATED_SNACKBAR',
      }),
      snackbarColor: 'success',
      label: intl.formatMessage(
        { id: 'NOTIFICATIONS.GROUP_CREATED' },
        { name: notification.data.gatewayThingName }
      ),
      onClick: () =>
        history.push(`/processing-groups/${notification.data.groupId}`),
    },
    'processing-group-deployment': {
      snackbarMessage: intl.formatMessage(
        {
          id: notification.data.finishedWithSuccess
            ? 'NOTIFICATIONS.GROUP_DEPLOYED.SUCCESS'
            : 'NOTIFICATIONS.GROUP_DEPLOYED.ERROR',
        },
        { name: notification.data.processingGroupName }
      ),
      snackbarColor: notification.data.finishedWithSuccess
        ? 'success'
        : 'error',
      label: intl.formatMessage(
        {
          id: notification.data.finishedWithSuccess
            ? 'NOTIFICATIONS.GROUP_DEPLOYED.SUCCESS'
            : 'NOTIFICATIONS.GROUP_DEPLOYED.ERROR',
        },
        { name: notification.data.processingGroupName }
      ),
      onClick: () => {},
    },
    'account-creation': {
      snackbarMessage: intl.formatMessage(
        { id: 'NOTIFICATIONS.ACCOUNT_CREATED' },
        { name: notification.data.name }
      ),
      snackbarColor: 'success',
      label: intl.formatMessage(
        { id: 'NOTIFICATIONS.ACCOUNT_CREATED' },
        { name: notification.data.name }
      ),
      onClick: () =>
        history.push(
          `/administration/business-entities/${notification.data.businessEntityId}`
        ),
    },
    'account-deletion': {
      snackbarMessage:
        notification.data.type !== 'error'
          ? intl.formatMessage({ id: 'NOTIFICATIONS.ACCOUNT_DELETED' })
          : intl.formatMessage({ id: 'NOTIFICATIONS.ACCOUNT_DELETION_ERROR' }),
      snackbarColor: notification.data.type !== 'error' ? 'success' : 'error',
      label:
        notification.data.type !== 'error'
          ? intl.formatMessage({ id: 'NOTIFICATIONS.ACCOUNT_DELETED' })
          : intl.formatMessage({ id: 'NOTIFICATIONS.ACCOUNT_DELETION_ERROR' }),
      onClick: () => {},
    },
    'tags-creation': {
      snackbarMessage:
        notification.data.type === 'event'
          ? intl.formatMessage({
              id: 'NOTIFICATIONS.CSV_PROCESSED_WITH_SUCCESS',
            })
          : intl.formatMessage({
              id: 'NOTIFICATIONS.CSV_PROCESSED_WITH_ERROR',
            }),
      snackbarColor: notification.data.type === 'event' ? 'success' : 'error',
      label:
        notification.data.type === 'event'
          ? intl.formatMessage({
              id: 'NOTIFICATIONS.CSV_PROCESSED_WITH_SUCCESS',
            })
          : intl.formatMessage({
              id: 'NOTIFICATIONS.CSV_PROCESSED_WITH_ERROR',
            }),
      onClick: () => {},
    },
  };

  return opts[notification.event];
};
